import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type SelectedService from '../services/kolay/selected.ts';
import type { ComponentLike } from '@glint/template';
export class Page extends Component<{
    Blocks: {
        /**
     * If there was a compilation error, the `<:error>` block
     * will be active and pass the caller the error text from the compiler.
     *
     * Example:
     *
     * ```gjs
     * import { Page } from 'kolay/components';
     *
     * <template>
     *   <Page>
     *     <:error as |errorText|>
     *
     *       {{errorText}}
     *
     *     </:error>
     *     <:success></:success>
     *   </Page>
     * </template>
     * ```
     */ error: [error: string];
        /**
     * If compilation of the active page was successful, the `<:success>` black
     * will be active, and will pass the component reference to the caller.
     *
     * Example:
     * ```gjs
     * import { Page } from 'kolay/components';
     *
     * <template>
     *   <Page>
     *     <:error></:error>
     *     <:success as |prose|>
     *
     *       <prose />
     *
     *     </:success>
     *   </Page>
     * </template>
     * ```
     */ success: [prose: ComponentLike<{
            }>];
    };
}> {
    static{
        template(`
    {{#if this.selected.hasError}}
      {{yield this.selected.error to='error'}}
    {{/if}}

    {{#if this.selected.prose}}
      {{yield this.selected.prose to='success'}}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @service('kolay/selected')
    selected: SelectedService;
}
export default Page;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL252cC9EZXZlbG9wbWVudC9OdWxsVm94UG9wdWxpL2tvbGF5L3VpL3NyYy9jb21wb25lbnRzL3BhZ2UuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBDb21wb25lbnQgZnJvbSAnQGdsaW1tZXIvY29tcG9uZW50JztcbmltcG9ydCB7IHNlcnZpY2UgfSBmcm9tICdAZW1iZXIvc2VydmljZSc7XG5cbmltcG9ydCB0eXBlIFNlbGVjdGVkU2VydmljZSBmcm9tICcuLi9zZXJ2aWNlcy9rb2xheS9zZWxlY3RlZC50cyc7XG5pbXBvcnQgdHlwZSB7IENvbXBvbmVudExpa2UgfSBmcm9tICdAZ2xpbnQvdGVtcGxhdGUnO1xuXG5leHBvcnQgY2xhc3MgUGFnZSBleHRlbmRzIENvbXBvbmVudDx7XG4gIEJsb2Nrczoge1xuICAgIC8qKlxuICAgICAqIElmIHRoZXJlIHdhcyBhIGNvbXBpbGF0aW9uIGVycm9yLCB0aGUgYDw6ZXJyb3I-YCBibG9ja1xuICAgICAqIHdpbGwgYmUgYWN0aXZlIGFuZCBwYXNzIHRoZSBjYWxsZXIgdGhlIGVycm9yIHRleHQgZnJvbSB0aGUgY29tcGlsZXIuXG4gICAgICpcbiAgICAgKiBFeGFtcGxlOlxuICAgICAqXG4gICAgICogYGBgZ2pzXG4gICAgICogaW1wb3J0IHsgUGFnZSB9IGZyb20gJ2tvbGF5L2NvbXBvbmVudHMnO1xuICAgICAqXG4gICAgICogPHRlbXBsYXRlPlxuICAgICAqICAgPFBhZ2U-XG4gICAgICogICAgIDw6ZXJyb3IgYXMgfGVycm9yVGV4dHw-XG4gICAgICpcbiAgICAgKiAgICAgICB7e2Vycm9yVGV4dH19XG4gICAgICpcbiAgICAgKiAgICAgPC86ZXJyb3I-XG4gICAgICogICAgIDw6c3VjY2Vzcz48LzpzdWNjZXNzPlxuICAgICAqICAgPC9QYWdlPlxuICAgICAqIDwvdGVtcGxhdGU-XG4gICAgICogYGBgXG4gICAgICovXG4gICAgZXJyb3I6IFtlcnJvcjogc3RyaW5nXTtcbiAgICAvKipcbiAgICAgKiBJZiBjb21waWxhdGlvbiBvZiB0aGUgYWN0aXZlIHBhZ2Ugd2FzIHN1Y2Nlc3NmdWwsIHRoZSBgPDpzdWNjZXNzPmAgYmxhY2tcbiAgICAgKiB3aWxsIGJlIGFjdGl2ZSwgYW5kIHdpbGwgcGFzcyB0aGUgY29tcG9uZW50IHJlZmVyZW5jZSB0byB0aGUgY2FsbGVyLlxuICAgICAqXG4gICAgICogRXhhbXBsZTpcbiAgICAgKiBgYGBnanNcbiAgICAgKiBpbXBvcnQgeyBQYWdlIH0gZnJvbSAna29sYXkvY29tcG9uZW50cyc7XG4gICAgICpcbiAgICAgKiA8dGVtcGxhdGU-XG4gICAgICogICA8UGFnZT5cbiAgICAgKiAgICAgPDplcnJvcj48LzplcnJvcj5cbiAgICAgKiAgICAgPDpzdWNjZXNzIGFzIHxwcm9zZXw-XG4gICAgICpcbiAgICAgKiAgICAgICA8cHJvc2UgLz5cbiAgICAgKlxuICAgICAqICAgICA8LzpzdWNjZXNzPlxuICAgICAqICAgPC9QYWdlPlxuICAgICAqIDwvdGVtcGxhdGU-XG4gICAgICogYGBgXG4gICAgICovXG4gICAgc3VjY2VzczogW3Byb3NlOiBDb21wb25lbnRMaWtlPHt9Pl07XG4gIH07XG59PiB7XG4gIDx0ZW1wbGF0ZT5cbiAgICB7eyNpZiB0aGlzLnNlbGVjdGVkLmhhc0Vycm9yfX1cbiAgICAgIHt7eWllbGQgdGhpcy5zZWxlY3RlZC5lcnJvciB0bz0nZXJyb3InfX1cbiAgICB7ey9pZn19XG5cbiAgICB7eyNpZiB0aGlzLnNlbGVjdGVkLnByb3NlfX1cbiAgICAgIHt7eWllbGQgdGhpcy5zZWxlY3RlZC5wcm9zZSB0bz0nc3VjY2Vzcyd9fVxuICAgIHt7L2lmfX1cbiAgPC90ZW1wbGF0ZT5cblxuICBAc2VydmljZSgna29sYXkvc2VsZWN0ZWQnKSBkZWNsYXJlIHNlbGVjdGVkOiBTZWxlY3RlZFNlcnZpY2U7XG59XG5cbmV4cG9ydCBkZWZhdWx0IFBhZ2U7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFDM0MsU0FBUyxPQUFPLFFBQVEsaUJBQWlCO0FBRXpDLFlBQVkscUJBQXFCLGdDQUFnQztBQUNqRSxjQUFjLGFBQWEsUUFBUSxrQkFBa0I7QUFFckQsT0FBTyxNQUFNLGFBQWE7SUFDeEI7UUFDRTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7S0FvQkMsR0FDRCxRQUFRLE9BQU8sTUFBTTtRQUNyQjs7Ozs7Ozs7Ozs7Ozs7Ozs7OztLQW1CQyxHQUNELFVBQVUsT0FBTzs7OztJQUduQixNQUFBO1FBQUEsU0FBVSxDQUFBOzs7Ozs7OztFQVFWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQVJBO0lBVVYsQ0FBQyxRQUFRO0lBQTBCLFVBQVUsZ0JBQWdCO0FBQy9EO0FBRUEsZUFBZSxLQUFLIn0